module.exports = __webpack_public_path__ + "static/media/icono3.7abbf14a.png";